import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const DocumentCompare = ({ documents }) => {
  const [left, setLeft] = useState('');
  const [right, setRight] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const runComparison = async () => {
    if (!left || !right) {
      toast.error('Select two documents to compare');
      return;
    }

    if (left === right) {
      toast.error('Choose two different documents');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/api/documents/compare', {
        document_id_1: Number(left),
        document_id_2: Number(right),
      });
      setResult(data);
    } catch (error) {
      toast.error('Failed to compare documents');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel panel--spaced">
      <h3>Compare Documents</h3>
      <div className="comparison-header panel__controls">
        <select value={left} onChange={(event) => setLeft(event.target.value)}>
          <option value="">Select first document</option>
          {documents.map((doc) => <option key={`a-${doc.id}`} value={doc.id}>{doc.filename || `Document ${doc.id}`}</option>)}
        </select>
        <select value={right} onChange={(event) => setRight(event.target.value)}>
          <option value="">Select second document</option>
          {documents.map((doc) => <option key={`b-${doc.id}`} value={doc.id}>{doc.filename || `Document ${doc.id}`}</option>)}
        </select>
        <button className="btn btn--primary" onClick={runComparison} disabled={loading}>
          {loading ? 'Comparing...' : 'Compare'}
        </button>
      </div>

      {result && (
        <div className="comparison-content panel--spaced">
          <h4>Summary</h4>
          <p>{result.comparison_summary}</p>
          <h4>Similarities</h4>
          <ul>{(result.similarities || []).map((item, i) => <li key={`s-${i}`}>{item}</li>)}</ul>
          <h4>Differences</h4>
          <ul>{(result.differences || []).map((item, i) => <li key={`d-${i}`}>{item}</li>)}</ul>
        </div>
      )}
    </div>
  );
};

export default DocumentCompare;
